import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { isStaleChunkError, reloadForStaleChunk } from '@shared/utils/stale-chunk.util';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Lazy code that is not a route (e.g. pdfmake) fails as an unhandled rejection
// when a deploy removed its chunk; route chunks are handled in RouteLoadingService.
window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  if (isStaleChunkError(event.reason)) {
    reloadForStaleChunk();
  }
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err: any) => console.error(err));
